import { WecomConversationDataType } from "@packages/chat-sdk";
import { Store } from "./store";
export interface WecomChatStoreType {
  selectedConversation?: WecomConversationDataType;
  // 机器人列表
  robotOptions?: { label: string; value: string }[];
  toBePlayedAudios: {
    url: string;
    id: string;
    is_play: boolean;
  }[];
  nextAudioPlayIndex: number;
  // 群聊二维码，
  roomQRCodesMap: Record<string, string>;
}

export const wecomChatStore = new Store<WecomChatStoreType>(() => ({
  selectedConversation: undefined,
  robotOptions: [],
  toBePlayedAudios: [],
  nextAudioPlayIndex: -1,
  roomQRCodesMap: {},
}));
export const wecomChatStoreActions = {
  setSelectedConversation(payload?: WecomConversationDataType) {
    wecomChatStore.set({
      selectedConversation: payload,
    });
  },
  refreshToBePlayedAudios(
    audios: { url: string; id: string; is_play: boolean }[]
  ) {
    wecomChatStore.set({
      toBePlayedAudios: audios,
    });
  },
  refreshNextAudioPlayIndex(index: number) {
    wecomChatStore.set({
      nextAudioPlayIndex: index,
    });
  },
  setRobotOptions(payload: { label: string; value: string }[]) {
    wecomChatStore.set({
      robotOptions: payload,
    });
  },
  refreshRoomQRCodesMap(payload: Record<string, string>) {
    wecomChatStore.set({
      roomQRCodesMap: payload,
    });
  },
};
